import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";

import NavbarHeader from "../components/Headers/NavbarHeader";
import SidePanel, { MenuItem } from "../components/SidePanel/SidePanel";

const Layout = (props) => {
  const [sidebarVisible, setSidebarVisible] = useState(false);

  // Handle sidebar toggle
  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  };

  // Close sidebar when screen size changes to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setSidebarVisible(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Define menu items for this specific layout
  const menuItems: MenuItem[] = [
    { description: "Profile", href: "/user/profile" },
    { description: "Virtual Avatar", href: "/user/profile/virtual-avatar" },
    // You can add more menu items specific to this layout
  ];

  return (
    <>
      <main className="mainContainer">
        {/* Overlay for mobile when sidebar is open */}
        {sidebarVisible && (
          <div
            className="md:hidden sidebar-overlay"
            onClick={toggleSidebar}
            aria-hidden="true"
          ></div>
        )}

        {/* Always render the sidebar but control its visibility with CSS */}
        <SidePanel
          menuItems={menuItems}
          onCloseMobile={toggleSidebar}
          isVisible={sidebarVisible}
        />

        <div id="contentContainer" className="absolute inset-0 left-0">
          <div id="header" className="fixed z-40 right-0 left-0">
            <NavbarHeader onToggleSidebar={toggleSidebar} />
          </div>
          <div id="content" className="absolute inset-0 mt-[73px]">
            <Outlet />
          </div>
        </div>
      </main>
    </>
  );
};

export default Layout;
